import styled from 'styled-components';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: ${({ theme }) =>
    theme?.name === 'dark' ? 'rgba(0, 0, 0, 0.7)' : 'rgba(0, 0, 0, 0.5)'};
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  animation: fadeIn 0.2s ease-out;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

export const ModalContainer = styled.div`
  background: ${({ theme }) =>
    theme?.name === 'dark' ? '#1F2937' : '#ffffff'};
  border-radius: 12px;
  width: 90%;
  max-width: 800px;
  height: 500px;
  box-shadow: ${({ theme }) =>
    theme?.name === 'dark'
      ? '0 20px 25px -5px rgba(0, 0, 0, 0.5), 0 10px 10px -5px rgba(0, 0, 0, 0.3)'
      : '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'};
  animation: slideIn 0.3s ease-out;
  position: relative;
  overflow: hidden;

  @keyframes slideIn {
    from {
      transform: translateY(-20px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }

  @media (max-width: 768px) {
    width: 95%;
    height: 90vh;
    max-height: 600px;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 20px;
  right: 20px;
  background: ${({ theme }) =>
    theme?.name === 'dark' ? '#374151' : '#f3f4f6'};
  border: none;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  cursor: pointer;
  color: ${({ theme }) => (theme?.name === 'dark' ? '#9CA3AF' : '#6b7280')};
  transition: all 0.2s;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover:not(:disabled) {
    background: ${({ theme }) =>
      theme?.name === 'dark' ? '#4B5563' : '#e5e7eb'};
    color: ${({ theme }) => (theme?.name === 'dark' ? '#F3F4F6' : '#374151')};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const ModalContent = styled.div`
  display: flex;
  height: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const ModalSidebar = styled.div`
  width: 320px;
  background: ${({ theme }) =>
    theme?.name === 'dark' ? '#111827' : '#f9fafb'};
  padding: 32px;
  display: flex;
  flex-direction: column;
  border-right: 1px solid
    ${({ theme }) => (theme?.name === 'dark' ? '#374151' : '#e5e7eb')};

  @media (max-width: 768px) {
    width: 100%;
    max-width: 100%;
    padding: 20px 12px 16px 12px;
    border-right: none;
    border-bottom: 1px solid
      ${({ theme }) => (theme?.name === 'dark' ? '#374151' : '#e5e7eb')};
    box-sizing: border-box;
    overflow: hidden;
    /* Use same background as ModalContainer on mobile for better visibility */
    background: ${({ theme }) =>
      theme?.name === 'dark' ? '#1F2937' : '#ffffff'};
  }
`;

export const SidebarTitle = styled.h2`
  margin: 0 0 12px 0;
  font-size: 24px;
  font-weight: 600;
  color: ${({ theme }) =>
    theme?.name === 'dark' ? '#F3F4F6' : theme?.colors?.blueBlack};
  font-family: Arial, -apple-system, system-ui, BlinkMacSystemFont, 'Segoe UI',
    Roboto, 'Helvetica Neue', Ubuntu, sans-serif;
  text-transform: uppercase;
  letter-spacing: 0.5px;

  @media (max-width: 768px) {
    font-size: 18px;
    margin: 0 0 8px 0;
  }
`;

export const SidebarSubtitle = styled.p`
  margin: 0 0 32px 0;
  font-size: 14px;
  color: ${({ theme }) => (theme?.name === 'dark' ? '#9CA3AF' : '#6b7280')};
  line-height: 1.5;

  @media (max-width: 768px) {
    font-size: 13px;
    margin: 0 0 16px 0;
  }
`;

export const FormatList = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  max-width: 100%;
  overflow: hidden;
`;

export const FormatItem = styled.button`
  padding: 16px;
  background: ${(props) => {
    if (props.selected) {
      return props.theme?.name === 'dark'
        ? 'rgba(250, 70, 22, 0.1)'
        : '#FFF7ED';
    }
    return props.theme?.name === 'dark'
      ? 'rgba(255, 255, 255, 0.03)'
      : '#ffffff';
  }};
  border: 2px solid
    ${(props) => {
      if (props.selected) return props.theme?.colors?.primary || '#FA4616';
      return props.theme?.name === 'dark' ? 'transparent' : '#e5e7eb';
    }};
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
  text-align: left;
  width: 100%;
  box-sizing: border-box;

  &:hover:not(:disabled) {
    background: ${(props) => {
      if (props.selected) {
        return props.theme?.name === 'dark'
          ? 'rgba(250, 70, 22, 0.15)'
          : '#FFF7ED';
      }
      return props.theme?.name === 'dark'
        ? 'rgba(255, 255, 255, 0.05)'
        : '#f3f4f6';
    }};
    border-color: ${(props) =>
      props.selected
        ? props.theme?.colors?.primary || '#FA4616'
        : props.theme?.name === 'dark'
        ? '#374151'
        : '#d1d5db'};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  @media (max-width: 768px) {
    padding: 10px 12px;
  }
`;

export const FormatName = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme }) =>
    theme?.name === 'dark' ? '#F3F4F6' : theme?.colors?.blueBlack};
  margin-bottom: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
  min-width: 0;

  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

export const FormatSize = styled.div`
  font-size: 12px;
  color: ${({ theme }) => (theme?.name === 'dark' ? '#6B7280' : '#9ca3af')};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
  min-width: 0;

  @media (max-width: 768px) {
    font-size: 11px;
  }
`;

export const ModalMain = styled.div`
  flex: 1;
  padding: 32px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 768px) {
    padding: 24px 16px;
  }
`;

export const PreviewArea = styled.div`
  text-align: center;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const PreviewIcon = styled.div`
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 768px) {
    margin-bottom: 16px;

    svg {
      width: 48px;
      height: 48px;
    }
  }
`;

export const PreviewTitle = styled.h3`
  margin: 0 0 16px 0;
  font-size: 28px;
  font-weight: 600;
  color: ${({ theme }) =>
    theme?.name === 'dark' ? '#F3F4F6' : theme?.colors?.blueBlack};
  font-family: Arial, -apple-system, system-ui, BlinkMacSystemFont, 'Segoe UI',
    Roboto, 'Helvetica Neue', Ubuntu, sans-serif;
  text-transform: uppercase;
  letter-spacing: 0.5px;

  @media (max-width: 768px) {
    font-size: 20px;
    margin: 0 0 12px 0;
  }
`;

export const PreviewDescription = styled.p`
  margin: 0 0 32px 0;
  font-size: 14px;
  color: ${({ theme }) => (theme?.name === 'dark' ? '#9CA3AF' : '#6b7280')};
  line-height: 1.6;

  @media (max-width: 768px) {
    font-size: 13px;
    margin: 0 0 24px 0;
  }
`;

export const ExportButton = styled.button`
  background: ${(props) => props.theme?.colors?.primary || '#fa4616'};
  color: #ffffff;
  border: none;
  padding: 14px 32px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  font-family: Arial, -apple-system, system-ui, BlinkMacSystemFont, 'Segoe UI',
    Roboto, 'Helvetica Neue', Ubuntu, sans-serif;
  text-transform: uppercase;
  letter-spacing: 0.5px;

  &:hover:not(:disabled) {
    background: #e63e13;
    transform: translateY(-2px);
    box-shadow: 0 8px 16px rgba(250, 70, 22, 0.3);
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none;
  }

  @media (max-width: 768px) {
    width: 100%;
    padding: 12px 24px;
    font-size: 15px;
  }
`;
